

import React from "react";
import { Box,useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import profiledone from "../../../assets/profiledone.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import face from "../../../assets/face.png";
import verifyface from "../../../assets/verifyface.png";
import { useTranslation } from "react-i18next";
import { useEffect,useState } from "react";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
const RegisterationVerification = () => {
      const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm","md"));
        const isLaptop = useMediaQuery(theme.breakpoints.between("md","lg"));
  const navigate = useNavigate();
    const { t } = useTranslation();   

  const location = useLocation();
const [isContinueClicked, setIsContinueClicked] = useState(false);
  // ✅ get face url from navigate state
  const faceUrl = location.state?.faceUrl;
const handleContinue = () => {
  setIsContinueClicked(true);
  // toast.success(t("verificationSuccessToast"));
    toast.success(t("verificationSuccessToast"), {
                id: "verification-success" // unique toast ID
              });
  setTimeout(() => {
    navigate("/admin-approval");
  }, 2000); 
}
  return (
    <Box sx={{ py:isMobile?5: 8, px: 2 }}>
        {/* <Toaster/> */}
                 <Box sx={{ display: 'flex', justifyContent: 'center',
                                       minHeight: "100vh",
                                        alignItems: "center",
                                     }}>
      <BaseCard maxWidth={isMobile ? "100%" : isTablet?"60%":isLaptop? "40%":"30%"}>
        <CustomText
          sx={{ ...textStyles.h4, color: "#172B4D", textAlign: "center", fontSize: "26px",letterSpacing:"0px !important" }}
        >
            {t("verificationCompleteTitle")}
        </CustomText>
        <CustomText
          sx={{ ...textStyles.body5, color: "#6B778C", pt: 1.2, textAlign: "center" ,letterSpacing:"0px !important"}}
        >
      {t("verificationCompleteSubtitle")}
        </CustomText>
      {/* <Box sx={{mt:4,px:2,display:"flex",justifyContent:"center",alignItems:"center"}}>
        <img 
            crossOrigin="anonymous"
        src={faceUrl || "/fallback-face.png"}
         style={{width:"80%",height:"80%",objectFit:"contain"}}/>
        </Box> */}

          <Box sx={{ display: "flex", justifyContent: "flex-end",mt: 4,gap:2 }}>
            <CustomButton
              disabled={isContinueClicked} 
                    label={t("back")}
              variant="text"
              onClick={() => navigate(-1)}
              sx={{ color: "black", px:0,backgroundColor:"white" , height:20, 
                                        backgroundColor: isContinueClicked ? "#f0f0f0" : "white", // light grey if disabled
    color: isContinueClicked ? "#999" : "black",
    "&:hover": {
      backgroundColor: isContinueClicked ? "#f0f0f0" : "white",
      color: isContinueClicked ? "#999" : "black",
    },
  }}
            />
            <CustomButton      label={t("continue")}  size='medium'  onClick={handleContinue} sx={{px:4,height:20}} />
          </Box>
      </BaseCard>
      </Box>
    </Box>
  );
};


export default RegisterationVerification;